import { render, staticRenderFns } from "./MaterialRequirements.vue?vue&type=template&id=6e047a91&scoped=true"
import script from "./MaterialRequirements.vue?vue&type=script&lang=js"
export * from "./MaterialRequirements.vue?vue&type=script&lang=js"
import style0 from "./MaterialRequirements.vue?vue&type=style&index=0&id=6e047a91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e047a91",
  null
  
)

export default component.exports